import { useAuth } from '../AuthContext';
import { applyPlurals } from './plurals';
import en from './en';
import es from './es';
import pt from './pt';
import ja from './ja';
import hi from './hi';
import zh from './zh';
import de from './de';
import fr from './fr';
import ru from './ru';
import tr from './tr';
import pl from './pl';
import it from './it';
import ar from './ar';
import nl from './nl';
import ko from './ko';

const dictionaries = { en, es, pt, ja, hi, zh, de, fr, ru, tr, pl, it, ar, nl, ko };

export function getLanguage(userData) {
  if (userData?.preferences?.language) return userData.preferences.language;
  const stored = localStorage.getItem('magi_language');
  if (stored && dictionaries[stored]) return stored;
  const browser = navigator.language?.slice(0, 2);
  if (browser && dictionaries[browser]) return browser;
  return 'en';
}

export function useLanguage() {
  const { userData } = useAuth();
  return getLanguage(userData);
}


export function useT() {
  const { userData } = useAuth();
  const lang = getLanguage(userData);
  const dict = dictionaries[lang] || en;

  return function t(key, vars) {
    let str = dict[key] ?? en[key] ?? key;
    str = applyPlurals(str, vars, lang);
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replaceAll(`{${k}}`, String(v));
      });
    }
    return str;
  };
}
